// 法语 French
import frLocale from "element-ui/lib/locale/lang/fr";
const fr = {
  login: {
    buttoo: {
      add: "add",
    },
  },
  dialog: {
    buttton: {
      close: "Fermer",
    },
    ReportError: {
      //未对应
      next: "Next",
      h1: "Report Errors allows users to communicate with us to solve any data issues and improve data quality.",
      li1: "If you find any data problems or have a question about this data",
      li2: "If you want to contribute company information to improve this data",
      li3: "If you choose not to disclose your own company information that you might consider private",
      li4: "If you have any constructive suggestions for us to improve services",
      h2: "All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company.",
    //未对应
    },
  },
  Home: {
    //未对应
    Applications: "Applications",
    SearchCompanies: "Search Companies",
    SearchTrade: "Search Trade",
    SearchRisks: "Search Risks",
    SearchCountries: "Search Countries",
    SearchNews: "Search News",
    SearchLeads: "Search Leads",
    SearchSanctions :"Search Sanctions ",
    RiskScan:"Risk Scan",
    SearchRelationship :"Search Relationship",
    DataServices :"Data Services",
    //未对应
    selectCountry: "Sélectionner un pays",
    inputCompany: "Entrez le nom de l'entreprise",
    keWord: "Mot-clé",
    firstWord: "Texte (mots de gauche)",
    search: "Recherche",
    homeSeachTitle: "Pleins feux sur les entreprises",
    homeTitleDetail:"CSI, cabinet de recherche et d'informatique axé sur les données, est spécialisé dans le crédit, le risque et le big data. Il propose des outils numériques aux investisseurs et aux professionnels du monde entier, exploitant des analyses et des algorithmes avancés pour fournir des informations visuelles rapides et faciliter la prise de décision.",
    phoneTitleDetail:"Pour rechercher, consulter et obtenir rapidement des informations sur les entreprises, vous pouvez également utiliser l'application CSI sur votre téléphone.",
    
    //未对应
    searchCompanyNum:"Rechercher plus de 500 millions d'entreprises dans plus de 200 pays et territoires",
    IndustryAnalysis: "Industry Analysis",
    BusinessAnalytics: "Business Analytics",
    ImportExportData: "Import-Export Data",
    CompanyNews: "Company News",
    Sanctions: "Sanctions",
    BusinessIntelligence: "Business Intelligence",
    CompanyIdentityVerification: "Company Identity Verification",
    KYCSolutions: "KYC Solutions",
    OwnershipPenetration: "Ownership Penetration",
    CompanyFinancialAnalysis: "Company Financial Analysis",
    CreditRatings: "Credit Ratings",
    CreditReports: "Credit Reports",
    ESGRatings: "ESG Ratings",
    VendorScreening: "Vendor Screening ",
    MarketResearch: "Market Research ",
    //未对应
  },
  Toolbar: {
    Filter: "Filtrer",
    Select: "Sélectionner",
    Edit: "Modifier",
    Sortby: "Trier par",
    Collect: "Collecter",
    Saved: "Enregistré",
    Compare: "Comparer",
    Export: "Exporter",
    Download: "Télécharger",
    Update: "Mettre à jour",
    Reporterror: "Signaler une erreur",
    Share: "Partager",
    //未对应
    ascending: "Ascending",
    descending: "Descending",
    Customfolder: "Custom folder",
    //未对应
  },
  AiZaba: {
    //未对应
    whatareyousearchingfor: "What are you searching for?",
    CreditAnalyst: "Credit Analyst",
    Assesses:"Assesses a company'screditworthiness,identifiesfinancial risks,ensuring secure transactionsthrough data analysis andcredit ratings.",
    LegalAdvisor: "Legal Advisor",
    Provides:"Provides compliance guidance,reviews contracts,andassesseslegarisks to ensure businessoperations align with lawsand avoid disputes.",
    BizConsultant: "Biz Consultant",
    Optimizes:"Optimizes supply chains,identifiesbuyers, andboosts sales by analyzingmarket trends and offeringtailored strategies to improve efficiency",
    EconomicAnalyst: "Economic Analyst",
    Analyzes:"Analyzes industry and regional economic trendshelping businesses makeinformed decisions, and staycompetitive.",
    //未对应
  },
  navigationBar: {
    Notifications: "Notifications", //通知
    MarkasRead: "Marquer comme lu", //标记已读
    Viewall: "Tout afficher", //查看全部
    SilverSubscriber: "Abonné Silver", //银级用户
    Silversubscriberdate: "Date d'expiration de l'abonnement Silver", //银级到期日
    GoldSubscriber: "Abonné Gold", //金级用户
    Goldsubscriptiondate: "Date d'expiration de l'abonnement Gold", //金级到期日
    AvailableCredits: "Crédits disponibles", //可用积分
    AddCredits: "Ajouter des crédits", //购买积分
    IndivdualAccount: "Compte individuel", //个人账号
    GroupAccount: "Compte de groupe", //集团账号
    //未对应
    OrdinaryUsers:"Ordinary users",
    UserAccount: "User Account",
    Roles: "Postes", //角色
  },
  ListofResults: {
    Country:'Pays',
    Industry:'Secteur',
    CompanyType:"Type d'entreprise",
    CompanySize:"Taille de l'entreprise",
    CompanyStatus:"Statut de l'entreprise",
    CompanyName:"Nom de l'entreprise",
    CoType:"Type d'entreprise",
    RegStatus:"Statut d'immatriculation",
    StateProvince:'État/Province',
    CityCounty:'Ville/Comté',
    DistrictCity:'District/Ville',
    IncDate:'Date de constitution',
    LegalForm:'Forme juridique',
    CoID:"Numéro d'identification de l'entreprise",
    TaxNo:'N° fiscal',
    ListingInfo:"Informations d'inscription",
    Phone:'Téléphone',
    Website:'Site web',
    Email:'E-mail',
    LegalPerson:'Personne morale',
    PostCode:'Code postal',
    ISIC:'ISIC',
    IndustryDescription:'Description du secteur',
    NACE:'NACE',
    NAICS:'NAICS',
    CreditRating:'Notation de crédit',
    SolvencyIndex:'Indice de solvabilité',
    ProbabilityofDefault:'Probabilité de défaut',
    NoofEmployees:"Nombre d'employés",
    Revenue:"Chiffre d'affaires",
    TotalAsset:'Actif total',
    NetProfit:'Bénéfice net',
    ROA:'ROA',
    ROE:'ROE',
    ShowMore:'Afficher plus',
    //未对应
    SelectCountry: "Select Country",
    ClearAll: "Clear All",
    SelectIndustry: "Select Industry",
    ListedCompany: "Listed Company",
    YearsinBusiness: "Years in Business",
    Sharethisinformation: "Share this information",
    Pleaseaddress: "Please enter one or more email address",
    Example: "Example",
    message: "message",
    pleaseleaveamessage: "please leave a message",
    Include: "",
    thisaddress: "this company name,ID,address",
    CSIwebsite: "CSI website",
    Update: "Update",
    Iftheavailable:"If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.",
    Abusinesscredit:"A business credit report provides detailed information about the subject company’s identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.",
    Searchcompanies: "Search more emails on other companies",
    Rowsperpage: "Rows per page",
    Foundover:'Found over',
    results:'results',
    Remove:'Remove',
    Confirm:'Confirmer',
    Rescan:'Rescan'
    //未对应
  },
  ContentTabs: {
    Background: "Contexte",
    BusinessActivities: "Activités commerciales",
    Performance: "Performance",
    Publications: "Publications",
    CreditOpinion: "Avis de crédit",
    MarketAnalysis: "Analyse de marché",
    Snapshot: "Aperçu",
    Profile: "Profil",
    Ownership: "Actionnariat",
    RelatedCompanies: "Sociétés liées",
    Management: "Direction",
    Operations: "Opérations",
    Locations: "Implantations",
    Industry: "Secteur",
    ImportExport: "Importation et exportation",
    SupplyChain: "Chaîne d'approvisionnement",
    FinancialHighlights: "Points financiers marquants",
    RatioAnalysis: "Analyse des ratios",
    IndustryNorm: "Norme du secteur",
    News: "Actualités",
    Sanctions: "Sanctions",
    IndustryStatistics: "Statistiques du secteur",
    RatingAnalysis: "Analyse des notations",
    CompetitiveAnalysis: "Analyse concurrentielle",
  },
  Snapshot: {
    //未对应
    CompanyDQIdesc1:'The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.',
    CompanyDQIdesc2:'The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.',
    CompanyDQIdesc3:'Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.',
    CountryDQIdesc1:'The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices.',
    CountryDQIdesc2:'Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.',
    //未对应
    CompanyDQI: "DQI de l'entreprise", //公司数据质量指数 DQI
    CountryDQI: "Pays DQI", //国家数据质量指数 DQI
    CompanyTitle:'Data Quality Index (DQI) by Company',
    CountryTitle:'Data Quality Index (DQI) by Country',
    Address: "Adresse", //地址
    CountyCity: "Comté/Ville", //县/市
    ProvinceState: "Province/État", //省/州
    CountryRegion: "Pays/Région", //国家/地区
    ZipCode: "Code postal", //邮政编码
    Website: "Site web", //网站
    Email: "E-mail", //电邮
    Tel: "Tél.", //电话
    LastUpdate: "Dernière mise à jour", //最近更新
    DataSource: "Source des données", //数据来源
    LegalStatus: "Statut juridique", //法定状况
    CoID: "ID de l'entreprise", //公司ID
    CompanyType: "Type d'entreprise", //公司类型
    RegistrationDate: "Date d'enregistrement", //注册日期
    RegistrationStatus: "Statut d'enregistrement", //注册状态
    Listed: "Cotée", //上市信息
    CurrentOpperations: "Opérations actuelles", //经营状况
    IndustryCode: "Secteur d'activité", //行业代码
    BusinessActivities: "Activités commerciales", //主营业务
    NoofEmployees: "Nombre d'employés", //员工数量
    NoofShareholders: "Nombre d'actionnaires", //股东数量
    Management: "Direction", //管理状况
    Performance: "Performance", //业绩表现
    Revenue: "Chiffre d'affaires", //收入
    Assets: "Actifs", //资产
    ProfitLoss: "Bénéfice/Perte", //利润
    Growth: "Croissance", //公司增长
    Competitiveness: "Compétitivité", //竞争力
    CreditOpinion: "Avis de crédit", //信用状况
    CreditRating: "Notation de crédit", //信用评级
    CreditScore: "Score de crédit", //信用评分
    ESGRating: "Notation ESG", //ESG 评级
    Solvency: "Solvabilité", //偿还能力
    Sanctions: "Sanctions", //全球制裁
    CoName:"Nom de l'entreprise",
    //未对应
    RegName:"Reg. Name"
  },
  Profile: {
    CompareCompanies:'Compare Companies',//未对应
    AddaCompany:'Add a Company',//未对应
    CompanyProfile: "Profil de l'entreprise", //基本资料
    CompanyName: "Nom de l'entreprise", //公司名称
    NativeName: "Nom d'origine", //当地名称
    CompanyID: "Numéro d'identification de l'entreprise", //公司 ID
    VATNumber: "Numéro de TVA", //VAT号
    StockCode: "Code boursier", //股票代码
    Listed: "Cotation", //上市日期
    RegistrationDate: "Date d'immatriculation", //注册日期
    LegalForm: "Forme juridique", //公司性质
    CompanyType: "Type d'entreprise", //公司类型
    LegalStatus: "Statut juridique", //注册状态
    Jurisdiction: "Juridiction", //司法管辖区
    RegisteredAddress: "Adresse enregistrée", //注册地址
    ProvinceState: "Province/État", //省/州
    CountryRegion: "Pays/Région", //国家/地区
    ZipCode: "Code postal", //邮政编码
    OperatingAddress: "Adresse d'exploitation", //经营地址
    LastUpdate: "Dernière mise à jour", //最近更新
    DataSource: "Source des données", //数据来源
    History: "Historique", //历史记录
    //未对应
    RegisteredCapital: "Registered Capital",
    PaidinCapital: "Paid-in Capital",
    //未对应
    CountyCity: "Comté/Ville",
    
  },
  Ownership: {
    UltimateBeneficiary: "Bénéficiaire final", //最终受益人
    InvolvingIndividuals: "Particuliers", //涉及自然人股东
    InvolvingEnterprises: "Entreprises", //涉及法人股东
    ShareholderLevel: "Niveau d'actionnaire", //股东层级x
    Name: "Nom", //名称
    Country: "Pays", //国家/地区
    Location: "Localisation", //地点
    Type: "Type", //类型
    Shares: "Actions", //股份
    Relation: "Lien", //关系
    //未对应
    Individuals: "Individuals", //关系
    PartiesInvolved: "Parties Involved",
    RelatedCompany: "Related Company",
    CompanyShareholders: "Company Shareholders",
    NGOShareholders: "NGO Shareholders",
    NaturalPersonShareholder: "Natural Person Shareholder",
    SubjectInvestments: "Subject's Investments",
    //未对应
  },
  RelatedCompanies: {
    Total: "Total", //相关公司总计
    Entities: "Entités", //法人实体
    Countries: "Pays", //国家/地区
    Branches: "Succursales", //分支机构
    RelatedComp: "Sociétés liées", //关联公司
    Name: "Nom", //名称
    Country: "Pays", //国家/地区
    Location: "Localisation", //地点
    Type: "Type", //类型
    Relation: "Relation", //关系
    //未对应
    BranchOffices: "Branch Offices",
    Individuals: "Individuals",
    //未对应
  },
  Management: {
    Management: "Management", //管理层
    ContactInfo: "Coordonnées", //联系人信息
    Countries: "Pays", //国家/地区
    Name: "Nom", //名称
    Position: "Poste", //职位
    Department: "Service", //部门
    Country: "Pays", //国家/地区
    ShareholderNot: "Actionnaire ou non", //是否股东
    Relation: "Relations", //关系
    Verification: "Vérification", //已验证
    Searchmoreemails: "Rechercher d'autres adresses e-mail", //搜索更多电邮
    Roles: "Postes", //角色
    EducationLevel: "Niveau d'études", //教育程度
    Phone: "Téléphone", //电话
    Email: "E-mail", //电邮
    Verified: "Vérifié", //已验证
    Searchmore: "Rechercher d'autres adresses e-mail sur d'autres entreprises", //搜索更多其他公司的电邮
  
    //未对应
    Pleaseentername:"Please enter name",
    PleaseenterWebsite:"Please enter Website",
    UserSelfVerification:"User Self Verification",
    Userverified:"User verified",
  },
  Operations: {
    Operations: "Operations",//未对应
    LineofBusiness: "Secteur d'activité", //业务范围
    BusinessTerritories: "Territoires d'activité", //业务区域
    ImportExport: "Importation et exportation", //进出口信息
    Viewtradeinfo: "Voir plus d'informations commerciales", //查看更多贸易信息
    ProductsServices: "Produits/Services", //产品/服务
    Products: "Produits", //产品
    ProductImage: "Image du produit", //产品图片
    ProductName: "Nom du produit", //产品名称
    ProductDescription: "Description du produit", //产品描述
    Details: "Détails", //详情
    Addproductinformation: "Ajouter des informations sur le produit", //添加产品信息
    //未对应
    Showcaseyourcompany:"If you’d like to showcase your company’s products or services to the public, you can add your product and service information here. This is a great way to promote your business. Once we’ve reviewed your submission, your data will be published."
  },
  Locations: {
    Locations: "Locations",//未对应
    CoName: "Nom de l'entreprise", //业务范围
    Relationship: "Lien", //关系
    Type: "Type", //类型
    Country: "Pays", //国家/地区
    Location: "Localisation", //地点
    Address: "Adresse", //地址
    Edit: "Modifier", //编辑
    CompanyLocatiionsMap: "Emplacements de l'entreprise sur la carte", //地图中的公司位置
    Selectaddresstype: "Sélectionner le type d'adresse", //选择地址类型
    Subjectcompany: "Société concernée", //目标公司
    Subsidiary: "Filiale", //子公司
    RegisteredAddress: "Adresse du siège social", //注册地址
    OperationAddress: "Adresse de l'établissement", //运营地址
    All: "Tous", //全部
    //未对应
    Showlocation :"Show location ",
  },
  Industry: {
    IndustryTitle: "Intitulé du secteur", //IndustryTitle
    IndustryDescription: "Description du secteur", //IndustryDescription
    ISIC: "CITI", //ISIC
    ISICDescription: "Description CITI", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "Description NACE", //NACEDescription
    NAICS: "NAICS", //NAICS
    NAICSDescription: "Description SCIAN", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "Description CSIC", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "Description AAACIC", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "Description GICS", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "Montant total des importations", //进口总额
    TopImportCountry: "Principaux pays d'importation", //最大进口国家/地区
    TopImportProduct: "Principaux produits d'importation", //最大进口产品
    TotalExport: "Exportations totales", //出口总额
    TopExportCountry: "Principaux pays d'exportation", //最大出口国家/地区
    TopExportProduct: "Principaux produits d'exportation", //最大出口产品
    TradeVolume: "Volume des échanges", //贸易额
    ImportShipments: "Expéditions d'importation", //进口量
    ExportShipments: "Expéditions d'exportation", //出口量
    ImportCountries: "Pays d'importation", //进口国家/地区
    ExportCountries: "Pays d'exportation", //出口国家/地区
    ImportVolume: "Volume des importations", //进口量
    ExportVolume: "Volume des exportations", //出口量
    TopSuppliers: "Principaux fournisseurs", //主要供应商
    ByNumberofShipments: "Par nombre d'expéditions", //按出货量
    TopBuyers: "Principaux acheteurs", //主要买家
    ByNumberofShipments: "Par nombre d'expéditions", //按出货量
    ImportQuantity: "Quantité importée", //进口数量
    IncreaseDecreasexRate: "Taux d'augmentation/diminution", //增/减率
    ExportQuantity: "Quantité exportée", //出口数量
    ImportsExportsRecords: "Enregistrements d'importations et d'exportations", //进出口记录
    Date: "Date", //日期
    Product: "Produit", //产品
    HSCode: "Code SH", //HS 编码
    BuyerName: "Nom de l'acheteur", //买家名称
    Destination: "Destination", //目的地
    SupplierName: "Nom du fournisseur", //供应商名称
    Origin: "Origine", //原产地
    Amount: "Montant", //金额
    Details: "Détails", //详情
    //未对应
    Imports:'Imports',
    Exports:'Exports',
    Shipments:'Shipments',
    value:'value',
    ByNumberofvalue:'By Number of value',
    viewmoretradeinfo:'view more trade info',
    SearchHSCode:"Search HS Code",
    //未对应
  },
  SupplyChain:{
  //未对应
    Illustratesthesubjectcompany:"This chart illustrates the subject company’s “buy from” and “sell to” relationships. The larger the volume, the thicker the tube.",
},
  ShippingOrderDetails: {
    Date: "Date",
    MasterBillofLading: "Connaissement principal",
    Source: "Source",
    BillNo: "N° de facture",
    ImporterBuyer: "Importateur / Acheteur",
    ExporterSeller: "Exportateur / Vendeur",
    Name: "Nom",
    Address: "Adresse",
    Country: "Pays",
    Contact: "Contact",
    Email: "E-mail",
    CargoInfo: "Informations sur le fret",
    HSCode: "Code SH",
    Quantity: "Quantité",
    WeightUnit: "Unité de poids",
    ProductDescription: "Description du produit",
    Amount: "Montant",
    QuantityUnit: "Unité de quantité",
    Weight: "Poids",
    HSDescription: "Description SH",
    Incoterms: "Incoterms",
    ShippingInfo: "Informations d'expédition",
    Vessel: "Navire",
    Consignee: "Destinataire",
    MeansofTransport: "Moyen de transport",
    CountryofOrigin: "Pays d'origine",
    Voyage: "Voyage",
    Notifier: "Notificateur",
    CountryofDestnation: "Pays de destination",
    AddressofOrigin: "Adresse d'origine",
    Shipper: "Expéditeur",
    AddressofDestnation: "Adresse de destination",
    Container: "Conteneur",
    ContainerID: "ID du conteneur",
    ContainerType: "Type de conteneur",
    ContainerDescDode: "Description du conteneur",
    ContainerSize: "Taille du conteneur",
    ImportExport: "Importer / Exporter",//未对应
  },
  FinancialHighlight: {
    Revenue: "Chiffre d'affaires", //收入
    Profit: "Bénéfice", //利润
    Growth: "Croissance", //增长
    Liquidity: "Trésorerie", //现金流状况//未对应
    FinancialStructure: "Structure financière", //融资结构
    CreditOpinion: "Avis de crédit", //信用评估
    RiskIndicator: "Indicateur de risque", //风险指标
    Solvencyindex: "Indice de solvabilité", //偿还指数
    Year: "Année", //年份
    Change: "Variation", //变化
    NetProfit:"Bénéfice net",
    TotalAssets:"Total de l'actif",
    Equity:"Capitaux propres",
    GrossMargin:"Marge brute",
    ProfitMargin:"Marge bénéficiaire",
    ReturnonEquity:"Rendement des capitaux propres",
    CurrentRatio:"Ratio de liquidité",
    DebtRatio:"Taux d'endettement",
    FinancialHighlights: "Données financières des sociétés liées", //关联公司财务数据
    FinancialHighlightsTitle: "Points clés financiers des sociétés liées", //关联公司财务摘要
    CompanyName: "Nom de l'entreprise", //公司名称
    CompanyID: "Numéro d'identification de l'entreprise", //公司ID
    Country: "Pays", //国家/地区
    CompanyStatus: "Statut de l'entreprise", //公司状态
    Relations: "Relations", //关系
    Cancel: "Annuler", //取消
    Select: "Sélectionner",
    RatioAnalysis: "Analyse des ratios des sociétés liées", //关联公司比率分析
    //未对应
    Financialperformancedata:"Financial performance data is collected from various governmental sources and local credit reporting agencies. Additionally, market and industry research is used to calculate and model the data. For more detailed information about the actual operations and performance analysis, please contact our service team to request a company due diligence report.",
    Whenthesubjectsdata:"When the subject’s data is insufficient, or you’re interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject’s company’s shareholders, related companies, and more.",
    Byprovidingyou:"By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    PleaseSelectTheYeartoDisplay:"Please Select The Year to Display",
    SelectUptoThreeYears:"Select Up to Three Years",
  },
  RatioAnalysis: {
    ProfitabilityRatios:'Ratios de rentabilité',
    Year:'Année',
    Change:'Variation',
    Returnonequity :'Rendement des capitaux propres',
    Returnonassets:'Rendement des actifs',
    Profitmargin:'Marge bénéficiaire',
    Grossmargin:'Marge brute',
    OperatingRatios:"Ratios d'exploitation",
    Assetsturnover:'Rotation des actifs',
    Stockturnover:'Rotation des stocks',
    Salesperiod:'Période de vente',
    Collectionperiod:"Période d'encaissement",
    Creditperiod:'Période de crédit',
    StructuralRatios:'Ratios de structure',
    Currentratio:'Ratio de liquidité',
    Quickratio:'ratio de liquidité générale',
    Shareholdersliquidityratio:'Ratio de liquidité des actionnaires',
    Solvencyratio:'Ratio de solvabilité',
    Debtratio:"Ratio d'endettement",
    ProductivityRatios:'Ratios de productivité',
    Profitperemployee:'Bénéfice par employé',
    Operatingrevenueperemployee:"Revenu d'exploitation par employé",
    Shareholdersfundsperemployee:'Fonds propres par employé',
    Totalassetsperemployee:'Total des actifs par employé',
    GrowthRatios:'Ratios de croissance',
    Salesgrowthrate:'Taux de croissance des ventes',
    Netprofitgrowthrate:'Taux de croissance du bénéfice net',
    Totalassetsgrowthrate:'Taux de croissance du total des actifs',
    FinancialHighlights:'Données financières des sociétés liées',//关联公司财务数据
    RatioAnalysis:'Analyse des ratios des sociétés liées', //关联公司比率分析
    CompanyName:"Nom de l'entreprise",
    CompanyID:"Numéro d'identification de l'entreprise",
    Country:'Pays',
    CompanyStatus:"Statut de l'entreprise",
    Relations:'Relations'    
},
  IndustryNorms: {
    IndustryStatistics: "Statistiques sectorielles",
    ofcompaniesintheIndustry: "Nombre d'entreprises du secteur",
    oflistedCompaniesintheIndustry: "Nombre d'entreprises cotées",
    oflargecompaniesintheIndustry: "Nombre de grandes entreprises du secteur",
    ofSMEsintheIndustry: "Nombre de PME du secteur",
    ofcompaniesinsample: "Nombre d'entreprises de l'échantillon",
    ofcompaniesinloss: "Nombre d'entreprises déficitaires",
    Observations: "Observations",
    AverageValue: "Valeur moyenne",
    MedianValue: "Valeur médiane",
    MaximumValue10: "Valeur maximale : 10 %",
    MinimumValue10: "Valeur minimale : 10 %",
    SubjectCompany: "Entreprise concernée",
    YearsinBusiness: "Nombre d'années d'activité",
    TotalAssets: "Actif total",
    TotalEquity: "Capitaux propres",
    Revenue: "Chiffre d'affaires",
    NetEarning: "Bénéfice net",
    Returnonassets: "Rendement des actifs",
    Performance: "Performance",
    ProfitabilityRatios: "Ratios de rentabilité",
    Returnonequity: "Rendement des capitaux propres",
    Returnonassets: "Rendement des actifs",
    Grossmargin: "Marge brute",
    OperatingRatios: "Ratios d'exploitation",
    Stockturnover: "Rotation des stocks",
    Accountsreceivableturnover: "Rotation des créances clients",
    Assetsturnover: "Rotation des actifs",
    Totalassetturnover: "Rotation totale des actifs",
    StructuralRatios: "Ratios de structure",
    Currentratio: "Ratio de liquidité",
    Quickratio: "ratio de liquidité générale",
    Shareholdersliquidityratio: "Ratio de liquidité des actionnaires",
    GrowthRatios: "Ratios de croissance",
    Salesgrowthrate: "Taux de croissance des ventes",
    Netprofitgrowthrate: "Taux de croissance du bénéfice net",
    Totalassetsgrowthrate: "Taux de croissance de l'actif total",
  },
  Lawsuits:{
    //未对应
    Lawsutis: "Lawsutis",
    Date: "Date",
    CaseCategory: "Case Category",
    Title: "Title",
    CaseNo: "Case No.",
    CauseofAction: "Cause of Action",
},
  News: {
    Date: "Date", //日期
    Title: "Titre", //标题
    Source: "Source", //来源
    Impact: "Impact", //影响
    Searchcompanies: "Rechercher plus d'actualités sur d'autres entreprises", //国家/地区
    //未对应
    SearchforTitle:"Search for Title",
  },
  Sanctions: {
    Potentialcompliance: "Risques potentiels de non-conformité détectés", //检测到潜在合规风险
    SeachbuttonNo:"Aucun élément préjudiciable n'a été détecté concernant cette entreprise.", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes:"Pour rechercher d'autres dossiers de sanctions, cliquez sur le bouton « Rechercher des sanctions ».", //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "Rechercher des sanctions", //搜索制裁
    ViewDetails: "Voir les détails", //查看详情
    Sanctions: "Sanctions", //制裁
    Potentialcompliancerisks: "Risques potentiels de non-conformité", //潜在合规风险
    IDInfo: "Informations sur l'ID", //ID 信息
    IDType: "Type d'ID", //ID 类型
    IDDescription: "Description de l'ID", //ID 描述
    SanctionList: "Liste des sanctions", //制裁名单
    SanctionListInvolved: "Liste des sanctions concernées", //涉及的制裁名单
    StartDate: "Date de début", //生效日期
    EndDate: "Date de fin", //结束日期
    SourceList: "Liste des sources", //来源名单
    SourceName: "Nom de la source", //来源名称
    ProfileNotes: "Notes de profil", //主体资料
    Link: "Lien", //链接
    Name: "Nom", //名称
    //未对应
    AssociationList:"Association List",
    AssociationID:"Association ID",
    AssociationType:"Association Type",
  },
  CreditOpinion: {
    CreditAssessment: "Évaluation de crédit",
    CreditAssessmentfromtheRelatedCompanies:"Évaluation de crédit des sociétés liées",
    Year: "Année",
    CreditRating: "Notation de crédit",
    LocalCreditScore: "Score de crédit local",
    ProbabilityofDefault: "Probabilité de défaut",
    SolvencyIndex: "Indice de solvabilité",
    CreditLine: "Ligne de crédit",
    RiskIndicator: "Indicateur de risque",
    RelatedCreditAssessment: "Évaluation de crédit liée",
    CompanyName: "Nom de l'entreprise",
    CompanyID: "Identifiant de l'entreprise",
    Country: "Pays",
    CompanyStatus: "Statut de l'entreprise",
    Relations: "Relations",
    Cancel: "Annuler", //取消
    Select: "Sélectionner",
    //未对应
    LocalCreditScore: "Local Credit Score",
    SolvencyIndex: "Solvency Index",
    ProbabilityofDefault: "Probability of Default",
    RiskIndicator: "Risk Indicator",
    CreditAssessmentMessage1:
      "When the subject’s data is insufficient, or you’re interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject’s company’s shareholders, related companies, and more.",
    CreditAssessmentMessage2:
      "By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    LocalCreditRating: "Local Credit Rating",
    LocalCreditRatingDetail:
      "Driven by the power of big data, 3ARating is a quantitative rating system for private companies. It is a collaborative effort between 3ACredit and Creditreform Rating. The rating model is built based on a comprehensive evaluation of various key factors, including non-financial factors, financial factors, negative records, and industry-specific considerations. The rating model exhibits an impressive Gini coefficient, indicating its robustness and reliability. 3ARating spans a range of ratings, from the highest rating, 3A1, to the lowest rating class, 3A19.",
    CreditScore: "Credit Score",
    CreditScoreDetail:
      "Credit scores are calculated on a scale from 1 to 100, based on the credit rating obtained from local authorities. A higher score indicates better creditworthiness.",
    PossibilityofDefault: "Possibility of Default (PD)",
    PossibilityofDefaultDetail:
      "The Possibility of Default (PD) is a useful tool for risk assessment, focusing on short-term liquidity evaluation.",
    SolvencyIndexSI: "Solvency Index (SI)",
    SolvencyIndexSIDetail:
      "The Solvency Index (SI) is a highly effective and reliable early warning indicator that allows for a rapid assessment of the solvency of business partners. A higher SI value indicates a higher risk of default by a client. The SI ranges from 100, which is considered an excellent rating, to 600, where highly negative characteristics are present.",
    ExternalRating: "External Rating",
    DefaultProbability: "Default Probability(Pd1Year)",
    Rating:"3ARating (>=,<=)",
    PleaseSelectTheYeartoDisplay:"Please Select The Year to Display",
    SelectUptoThreeYears:"Select Up to Three Years",
    //未对应
  },
  IndustryStatistics: {
    SubjectCompany: "Entreprise concernée",
    Country: "Pays",
    Compare: "Comparer",
    Industry: "Secteur d'activité",
    CompanyType: "Type d'entreprise",
    CompanySize: "Taille de l'entreprise",
    CompanyStatus: "Statut de l'entreprise",
    YearsinBusiness: "Nombre d'années d'activité",
    CompanyRating: "Évaluation de l'entreprise",
    Liquidity: "Trésorerie",
    //未对应
    NoofcoinIndustry: "No. of co. in Industry",
    IndustryRating: "Industry Rating",
    Profitability: "Profitability",
    Repaying: "Repaying",
    SearchCountry: "Search Country",

    Growth: "Croissance",
    FinancialStructurt: "Structure financière",

  },
  RatingAnalysis: {
    IndustyAnalysis: "Analyse sectorielle",
    GeographicAnalysis: "Analyse géographique",
    CompanyTypeAnalysis: "Analyse du type d'entreprise",
    BiusinessScaleAnalysis: "Analyse de l'échelle d'activité",
    HistoryAnalysis: "Analyse historique",
    NormalDistribution: "Distribution normale",
    SubjectCompany: "Entreprise concernée",
    Probabilityofthesubjectratinginitsindustry:"Probabilité d'obtention d'une note dans son secteur",
    Maximum: "Maximum 10 %",
    Mean: "Moyenne",
    Average: "Moyenne",
    Minimum: "Minimum 10 %",
    RatingDistribution: "Distribution des notes",
    Revenue: "Chiffre d'affaires",
    Earning: "Bénéfices",
    TotalAssets: "Actifs totaux",
    Subjectratinginitsindustrybyfinancialindicators:"Note du sujet dans son secteur selon les indicateurs financiers",
    Best: "Meilleur",
    Worst: "Pire",
    Rankingofsubject: "Classement du sujet dans son secteur",
    Industy: "Secteur",
    Percentilerank: "Classement en percentile : % d'entreprises ayant obtenu une note égale ou inférieure à celle du sujet",
    Historicaldevelopmentofsubject:"Évolution historique de la note du sujet dans son secteur",
    IndustryAverage: "Moyenne du secteur",
    SubjectRatingChanges: "Évolution des notes du sujet",
    CompanySize:"Taille de l'entreprise",
    YearsinBusiness: "Nombre d'années d'activité",
    //未对应
    CreditScore:"Credit Score",
    NOofCompanies:"NO. of Companies",
    ofCompanies:"% of Companies",
    CreditRating:"Credit Rating",
    SubjectsIndustryConcentrationAnalysis:"Subject's Industry Concentration Analysis",
    GeographicdistributionofSubjectsratingintsindustry:"Geographic distribution of Subject's rating in its industry",
    GeographicdistributioninSubjectindustry:"Geographic distribution in Subject's industry：",
    RatingDistributioninSubjectsLocation:"Rating Distribution in Subject's Location",
    Ratinganalysisofcompanies:"Rating analysis of companies in the same industry with different years in business",
    Subjectsratinghistory:"Subject's rating history comparing with its peers with the same history",
    Ratingrankingofcompanieswithsamehistory:"Rating ranking of companies with same history",
    Ratingstatistics:"Rating statistics of companies with the same years in business",
    Subjectratingcomparing:"Subject rating comparing with its peer companies with the",
    Subjectratinginitsgroup:"Subject rating in its group:",
    Analysisbasedonnature:"Analysis based on nature of companies in subject's industry",
    Subjectratingpositioninitscompanytype:"Subject rating position in its company type:",
    Ratingstatisticsofcompanies:"Rating statistics of companies in the same industry",
    Ratinganalysisofcompanies:"Rating analysis of companies of different sizes in the same industry",
    Probabilityofsubjectrating:"Probability of subject rating in its industry within its size",
    Subjectratingcomparingwithindustry:"Subject rating comparing with its peers in its industry:",
    RatingRankingofthecompanies:"Rating Ranking of the companies in the same size in the same industry",
    Ratingstatisticsofcompanies:"Rating statistics of companies in the same size and same industry",
    Rank:"Rank",
    Rating:"Rating",
  },
  CompetitiveAnalysis: {
    MarketPosition: "Position sur le marché",
    Revenus: "Chiffre d'affaires",
    NetEarnings: "Bénéfice net",
    NetAssets: "Actif net",
    TotalAssets: "Actif total",
    Employees: "Employés",
    Mean: "Moyenne",
    Average: "Moyenne",
    Maximum: "Maximum (10 %)",
    Worst: "Pire (10 %)",
    Subjectcompany: "Entreprise concernée",
    PerformanceComparison: "Comparaison des performances",
    ProfitabilityRatios: "Ratios de rentabilité",
    Grossmargin: "Marge brute",
    Returnonassets: "Rendement des actifs",
    Returnonequity: "Rendement des capitaux propres",
    OperatingRatios: "Ratios d'exploitation",
    Stockturnover: "Rotation des stocks",
    Assetsturnover: "Rotation des actifs",
    Collectionperiod: "Période de collecte",
    GrowthRatios: "Ratios de croissance",
    Totalassetsgrowthrate: "Taux de croissance du total des actifs",
    Salesgrowthrate: "Taux de croissance des ventes",
    Netprofitgrowthrate: "Taux de croissance du bénéfice net",
    StructuralRatios: "Ratios de structure",
    Debtratio: "Ratio d'endettement",
    Quickratio: "ratio de liquidité générale",
    Currentratio: "Ratio de liquidité",
  },
  AccountCenterMenu: {
    SearchinSettings: "Rechercher dans les Paramètres", //在“设置”中搜索
    Account: "Compte", //账户
    MyAccount: "Mon compte", //我的账户
    ContactInfo: "Coordonnées", //联系信息
    AccountSecurity: "Sécurité du compte", //账户安全
    OrganizationalManagement: "Gestion organisationnelle", //组织管理
    UserGroup: "Groupe d'utilisateurs", //用户组
    User: "Utilisateur", //用户
    Role: "Rôle", //角色
    MyDatabase: "Mon utilisation", //我的数据库
    MyUsage: "Mon utilisation", //我的使用情况
    CompaniesViewed: "Entreprises consultées", //查看过的公司
    ReportsDownloaded: "Rapports téléchargés", //下载的报告
    ReportUpdatesOrdered: "Mises à jour de rapports commandées", //订购的报告更新
    BillingandPayment: "Facturation et paiement", //账单和付款
    BillRecords: "Enregistrements de factures", //账单记录
    PaymentRecords: "Enregistrements de paiement", //付款记录
    CreditDeductions: "Déductions de crédit", //信用扣款
    InvoicesDownloaded: "Factures téléchargées", //下载的发票
    UserSettings: "Paramètres utilisateur", //用户设置
    Messages: "Messages", //消息
    Notifications: "Notifications", //通知
    HelpCenter: "Centre d'aide", //帮助中心
    FAQ: "FAQ", //常见问题
    Privacy: "Conditions", //隐私
    Terms: "Conditions", //条款
    ReportIssues: "Guide de l'utilisateur", //报告问题
    UserGuide: "Guide de l'utilisateur", //用户指南
    AboutCSI: "À propos de CSI", //关于CSI
  },
  MyAccount: {
    Logintime: "Heure de connexion", //登录时间
    SignOut: "Déconnexion", //退出
    DeleteAccount: "Supprimer le compte", //删除账户
    AccountID: "Identifiant du compte", //账户ID
    Enteranewaddress: "Saisir une nouvelle adresse e-mail", //输入新的电邮
    EnterVerificationCode: "Saisir le code de vérification", //输入验证码
    SendverificationCode: "Envoyer le code de vérification", //发送验证码
    Password: "Mot de passe", //密码
    Originalpassword: "Mot de passe d'origine", //原始密码
    Newpassword: "Nouveau mot de passe", //新密码
    Confirmnewpassword: "Confirmer le nouveau mot de passe", //确认新密码
    AccountOwnership: "Propriétaire du compte", //账户所有权
    IndividualAccount: "Compte individuel", //个人账户
    GroupAccount: "Compte de groupe", //集团账户
    Organizationname: "Nom de l'organisation", //机构名称
    CountryRegion: "Pays/Région", //国家/地区
    Address: "Adresse", //地址
    City: "Ville", //城市
    ZipCode: "Code postal", //邮政编码
    FirstName: "Prénom", //名字
    LastName: "Nom", //姓氏
    PhoneNumber: "Numéro de téléphone", //电话号码
    Email: "E-mail", //更改
    Change: "Modifier", //更改
    Save: "Enregistrer", //保存
    Cancel: "Annuler", //取消
    LastLogin: "Dernière connexion", //Last Login
    RecentLogin: "Connexion récente", //登录尝试次数
    AverageLoginTime: "Durée moyenne de connexion", //平均登录时间
    TotalLoginAttempts: "Nombre total de tentatives de connexion", //登录尝试次数
    //未对应
    Registrationtime:"Registration time",
    Role: "Rôle",
    Administrator:"Administrator",
    Enterpriseusers:"Enterprise users",
    EditImage:"Edit Image",
    DeleteImage:"Delete Image",
  },
  ContactInfo: {
    ContactInfo: "Coordonnées",
    FirstName: "Prénom",
    LastName: "Nom",
    PhoneNumber: "Numéro de téléphone",
    Email: "E-mail",
    CountryRegion: "Pays/Région",
    AddressLine: "Adresse",
    City: "Ville",
    ZipCode: "Code postal",
    Alternativecontactperson: "Autre contact",
    Setascontactperson: "Définir comme contact",
    Edit: "Modifier",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "Configurer mes questions de sécurité",
    Pleasechooseaquestion: "Veuillez choisir une question",
    Pleaseentertheanswertothequestion:"Veuillez saisir la réponse à la question",
    SessionTimeoutAutomaticLogoutSettings:"Délai d'expiration de session : Paramètres de déconnexion automatique",
    Thesystemwillautomatically:"Le système vous déconnectera automatiquement après une période d'inactivité. Le délai d'expiration par défaut est de 5 minutes, mais vous pouvez l'ajuster selon vos besoins.",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "Nombre total d'entreprises recherchées",
    TotalNumberofCompaniesCollected: "Nombre total d'entreprises collectées",
    TotalNumberofUpdateReportsOrdered:"Nombre total de rapports de mise à jour commandés",
    Date: "Date",
    UserName: "Nom d'utilisateur",
    CompanyName: "Nom de l'entreprise",
    Status: "Statut",
    UsageType: "Type d'utilisation",
    Entercompanyname: "Saisir le nom de l'entreprise",
    Download: "Télécharger",
  },
  OrganizationalManagement: {
    GroupName: "Nom du groupe",
    ParentGroupName: "Nom du groupe parent",
    Organization: "Organisation",
    GroupID: "ID du groupe",
    GroupStatus: "Statut du groupe",
    Operation: "Opération",
    NewlyBuilt: "Nouvellement créé",
    UserAccount: "Compte utilisateur",
    Role: "Rôle",
    AccountStatus: "Statut du compte",
    RoleName: "Nom du rôle",
    Position: "Poste",
    RoleStatus: "Statut du rôle",
    Valid: "Valide",
    Invalid: "Invalide",
    PermissionSettings: "Paramètres d'autorisation",
    ShowMore:'Afficher plus',
    Search:'Recherche',
    Cancel:'Annuler',
    //未对应
    Confirm:'Confirmer',
    NewGroup:"New Group",
    EnterGroupName:"Enter Group Name",
    NumberofGroups:"Number of Groups",
    Groups:"Groups",
    Roles: "Postes",
    NewRoles:"New Roles",
    EnterNewRole:"Enter New Role",
    Users:"Users",
    EnterUserName:"Enter User Name",
  },
  BillingandPayment: {
    TotalNumberofOrders: "Nombre total de commandes",
    TotalPaymentAmount: "Montant total du paiement",
    TotalDeductionCredits: "Total des crédits de déduction",
    Date: "Date",
    UserAccount: "Compte utilisateur",
    CompanyName: "Nom de l'entreprise",
    OrderNo: "N° de commande",
    OrderType: "Type de commande",
    OrderStatus: "Statut de la commande",
    Download: "Télécharger",
    PaymentAmount: "Montant du paiement",
    Contactus: "Nous contacter",
    DownloadInvoice: "Télécharger la facture",
    CreditsDeducted: "Crédits déduits",
    ReportOrderStatus: "Statut de la commande",
    CompanyID: "Identifiant de l'entreprise",
    CountryRegion: "Pays/Région",
    AddressLine: "Adresse",
    City: "Ville",
    ZipCode: "Code postal",
    FirstName: "Prénom",
    LastName: "Nom",
    PhoneNumber: "Numéro de téléphone",
    Email: "E-mail",
    BankAccountHolderName: "Nom du titulaire du compte bancaire",
    BeneficiaryBankName: "Nom de la banque du bénéficiaire",
    SWIFTCODE: "CODE SWIFT",
    AccountNumber: "Numéro de compte",
    BeneficiaryBankAddress: "Adresse de la banque du bénéficiaire",
    ABA: "Numéro d'acheminement (ABA)",
    IBANnumber: "Numéro IBAN",
    //未对应
    StartingMonth:"Starting Month",
    EndMonth:"End Month",
  },
  UserSettings: {
    LanguageandLocation: "Langue et localisation",
    Language: "Langue",
    Selectyourpreferedlanguage: "Sélectionnez votre langue préférée",
    Location: "Localisation",
    Selectyourlocation: "Sélectionnez votre localisation",
    NotificationSetting: "Paramètres de notification",
    EmailNotification: "Notification par e-mail",
    ServiceUpdates: "Mises à jour du service",
    CompanyNews: "Actualités de l'entreprise",
  },
  AddCredit: {
    //未对应
    Customizeyourplan: "Customize your plan however you need",
    Silver: "Silver",
    Gold: "Gold",
    Enterpris: "Enterpris",
    Credit: "Credit",
    Remaining: "Remaining",
    Points: "points",
    Usermonth: "user/ month",
    Useryear: "user/ year",
    PaidMonthlyRenews: "Paid monthly, no need for auto renews",
    PaidAnnuallyRenews: "Paid annually, no need for auto renews",
    ForFullSupport: "for full support to your needs",
    Each: "each",
    CreditsCharged:
      "Credits charged to your account will never expire as long as your account remains active.",
    PaidMonthly: "Paid monthly",
    PaidAnnually: "Paid annually",
    BuyNow: "Buy now",
    ContactNow: "Contact now",
    SearchCompanies:
      "Search companies and get an instant access to company data that includes:",
    EverythinginSilverPackage: "Everything in Silver package, plus:",
    CreditsCanbeUsed:
      "Credits can be used for more data services including the followings:",
    UnlimitedAdvancedSearch: "Unlimited advanced search",
    ViewCompanyProfile: "View company profile",
    CompanyOwnershipStructure: "Company ownership structure",
    CompanyFamilyTree: "Company family tree",
    Companymanagement: "Company management",
    CompanyContactsinfo: "Company contacts info",
    BusinessActivities: "Business activities",
    IndustryBasics: "Industry basics",
    ImportExportRecords: "Import & export records",
    CompanyPublications: "Company publications",
    CompanyNews: "Company news",
    DownloadOnlineReport: "Download online report",
    ManagementDetails: "Management details",
    ShareholderPenetration: "Shareholder penetration (UBO)",
    Financialinfo: "Financial info",
    FinancialAnalysis: "Financial analysis",
    CreditAssessment: "Credit assessment",
    IndustryAnalysis: "Industry analysis",
    MarketAnalysis: "Market analysis",
    SupplyChaininfo: "Supply Chain info",
    CheckSanctions: "Check sanctions",
    CompanyComparison: "Company comparison",
    DataExport: "Data export",
    MonitoringService: "Monitoring service",
    DiscountForFreshUpdateReports: "Discount for fresh update reports",
    SearchCompany: "Search Company",
    SearchLeads: "Search Leads",
    SearchTrade: "Search Trade",
    SearchPeople: "Search People",
    SearchCountry: "Search Country",
    SearchNews: "Search News",
    SearchSanction: "Search Sanction",
    DataServices: "Data Services",
    APIPlans: "API Plans",
    VolumeDiscounts: "Volume Discounts",
    GroupAccountsWithMultipleUsers: "Group Accounts with multiple users",
    CustomizedPlans: "Customized Plans",
    FreshInvestigatedCreditReportsWorldwide:
      "Fresh investigated credit reports worldwide",
    BusinessMonitoringServices: "Business monitoring services",
    BusinessProcessVerificationServices:
      "Business process verification services",
    VendorComplianceReports: "Vendor compliance reports",
    MarketResearch: "Market research",
    More: "More…",
    Contactus: "Contact us",
    PaymentMethod:"Payment Method",
    CreditCardNumber:"Credit Card Number",
    EnterCardNumber:"Enter Card Number",
    ExpirationDate:"Expiration Date",
    Fullnameoncard:"Full name on card",
    EnterFullname:"Enter Full name",
    EnterProvinceState:"Enter Province / State",
    CVCCode:"CVC Code",
    EnterCVCCode:"Enter CVC Code",
    IncorrectCreditCardNumberformat :"Incorrect Credit Card Number format ",
    IncorrectExpMonthformat:"Incorrect Exp.Month format",
    IncorrectExpYearformat:"Incorrect Exp.Year format",
    IncorrectFullNameformat:"Incorrect Full Name format",
    IncorrectCountryformat:"Incorrect Country format",
    IncorrectProvinceStateformat:"Incorrect Province / State format",
    IncorrectCVCCodeformat:"Incorrect CVC Code format",
    TotalPurchase:"Total Purchase",
    Agree1: "By clicking “Submit”, you agree to the ",
    Agree2:"CSI Services Agreement and Privacy .",
    Submit:"Submit",
    Month:"Month",

    Year: "Année",
    Country: "Pays",
    ProvinceState: "Province/État",
    Cancel: "Annuler",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting: "Quel type d'erreurs signalez-vous ?",
    Tellusmoreaboutyourproblems: "Décrivez-nous vos problèmes.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:"Souhaitez-vous fournir une capture d'écran ou un fichier concernant votre problème ?",
    Fillinyourcontactinformation: "Indiquez vos coordonnées",
    FirstName: "Prénom",
    LastName: "Nom",
    PhoneNumber: "Numéro de téléphone",
    Email: "E-mail",
    Edit: "Modifier",
  },
  //Risk Scan
RiskScan:{
  RiskScan:"Risk Scan",
  RiskScanInfo:" est votre plateforme tout-en-un pour une analyse complète des risques d'entreprise. Nous fournissons une analyse détaillée de chaque catégorie de risques majeure afin de sécuriser vos décisions commerciales.",
  LegalRisk:"Risque juridique",
  LegalRiskInfo:"Vérifier la légitimité de l’entreprise.",
  OrganizationalRisk:"Risque organisationnel",
  OrganizationalRiskInfo:"stabilité de la direction, complexité de la structure de l’entreprise et transparence de la propriété.",
  OperationalRisk:"Risque opérationnel",
  OperationalRiskInfo:"vulnérabilités de la chaîne d'approvisionnement, situation opérationnelle et exposition géopolitique.",
  FinancialRisk:"Risques liés à la performance financière",
  FinancialPerformanceRiskInfo:"tendances de rentabilité, problèmes de liquidités et santé du bilan.",
  CreditRisk:"Risque de crédit",
  CreditRiskInfo:"solvabilité, historique de paiement et probabilité de défaut de paiement.",
  ComplianceRisk:"Risque de non-conformité",
  ComplianceRiskInfo:"respect des sanctions, des réglementations en matière de lutte contre le blanchiment d’argent et des lois spécifiques au secteur.",
  SustainabilityRisk:"Risques liés au développement durable",
  SustainabilityRiskInfo:"facteurs ESG (environnementaux, sociaux et de gouvernance) et impacts sur la réputation.",
  IndustryRisk:"Risque sectoriel",
  IndustryRiskInfo:"Évalue la stabilité et les perspectives de l'ensemble du secteur d'activité d'une entreprise.",
  LetBegin:"Commençons",
  AddcompaniesfromSearchResult:"Ajouter des entreprises à partir des résultats de recherche",
  AddcompaniesfromMyDatabase:"Ajouter des entreprises depuis Ma base de données",
  Addcompaniesbyuploadmyownlist:"Ajouter des entreprises en important ma propre liste",
  Cancel: "Annuler",
  Confirm:"Confirmer",
  UploadFiles:"Téléverser des fichiers",
  PleaseuploadyourfileinCVSformat:"Veuillez téléverser votre fichier au format xlsx.",
  Downloadxlsxtemplate:"Télécharger le modèle xlsx",
  //语序问题未对应
  Xcompanieswereuploadedsucessfuly:"companies were uploaded sucessfuly.",
  Xcompanieswereidentifiedsucessfuly:"companies were identified sucessfuly.",
  Xcompanieswerenotmatched:"companies were not matched.",

  Uploadingfilefailed:"Le chargement du fichier a échoué. Veuillez utiliser le modèle et réessayer.",
  ALL:"Tous",
  SearchLeads:"Recherche de prospects",
  LastUpdate:"Dernière mise à jour",
  CompanyID:"ID de l'entreprise",
  CompanyType:"Type d'entreprise",
  RegistrationDate:"Date d'inscription",
  RegistrationStatus:"État d'inscription",
  Listed:"cotée en bourse",
  LegalStatus:"Statut juridique",
  NoofShareholders:"Nombre d'actionnaires",
  ShareholdingLayers:"Niveaux d'actionnariat",
  NoofCorporateShareholders:"Nombre d'actionnaires personnes morales",
  NoofNatualPersonShareholders:"Nombre d'actionnaires personnes physiques",
  RelatedCompanies:"Entreprises apparentées",
  OrganizationalStatus:"Statut organisationnel",
  OperatingAddress:"Adresse d'exploitation",
  IndustryCode:"Code industriel",
  BusinessActivities:"Activités commerciales",
  NoofEmployees:"Nombre d'employés",
  Management:"Gestion",
  CurrentOperations:"Opérations en cours",
  Revenue:"chiffre d'affaires",
  Assests:"Actifs",
  ProfitLoss:"Profit/Perte",
  Liquidity:"Liquidité",
  Growth:"croissance",
  Performance:"performance opérationnelle",
  CreditRating:"notation de crédit",
  CreditScore:"Score de crédit",
  PausibilityofDefault:"Pausibilité du défaut (PD)",
  SolvencyIndex:"Indice de solvabilité",
  DebtCollection:"recouvrement de créances",
  CreditOpinion:"Avis de crédit",
  CompanySanction:"des sanctions contre les entreprises",
  ProductSanction:"Sanction du produit",
  ExportControl:"Contrôle des exportations",
  AntiCorruptionAntiBribery:"Lutte contre la corruption",
  Litigations:"Litiges",
  NegativeNews:"Nouvelles négatives",
  ESGScore:"Score ESG",
  YearsinBusiness:"Années d'activité",
  Competitiveness:"Compétitivité",
  WorkingCapital:"Risque de marché",
  FinancialStructure:"Indice de la chaîne d'approvisionnement",
  Industrystatus:"État de l'industrie",
  IndustryOutlook:"Perspectives du secteur",
  NoofCompanies:"Nombre d'entreprises",
  IndustryRanking:"Classement de l'industrie",
  IndustryConcentration:"PIB industriel %",
  IndustryCompetitiveness:"Industry Competitiveness",//未对应
  IndustryDevelopment:"Industry Development",//未对应
  CompanyName:"Nom de l'entreprise",
  Legal:"juridique",
  Organizational:"organisationnel",
  Operational:"opérationnel",
  Financial:"liés à la performance financière",
  Credit:"de crédit",
  Compliance:"de non-conformité",
  Sustainability:"liés au développement durable",
  Industry:"sectoriel",
  Download:"Télécharger",
  StartDate: "Date de début", 
  EndDate: "Date de fin", 
  Entercompanyname: "Saisir le nom de l'entreprise",
  Tryagain:"Essayer à nouveau",
  //未对应
  Uploadyourlistofcompanies:"Upload your list of companies, and Risk Scan will provide you with instant data updates for each entity. With comprehensive risk assessments across seven risk categories, Risk Scan transforms your risk management from reactive to a proactive strategic advantage.",
  Choose:"Choose",
  Upload:"Upload",
  Uploading:"Uploading",
  Uploadwithamaximumfilesizeof1M:"（Upload up to 100 pieces of data at a time, with a maximum file size of 1M）",
  Theuploadedonlyxlsx:"The uploaded file can only be in xls/xlsx format",
  RiskScanning:"Risk Scanning",
  Youhaveselectedatotalof:"You have selected a total of",
  Tostartriskscanning:"companies, click “confirm” to start risk scanning",
  Datascanningisinprogress:"Data scanning is in progress ...",
  ClearAll:'Clear All',
  SelectUpdateDate:"Select Last Update",
  UpdateStatus:"Update Status",
  Updated:"Updated",
  Notupdated:"Not updated",
  Updating:"Updating",
  SelectRiskValue:"Select Risk Value",
  ReSelectData:"Re Select Data",
  HistoricalData:"Historical Data",
  DiagnosticReport:"Diagnostic Report",
  Good:"Good",
  General:"General",
  Differ:"Differ",
  NotEvaluated:"Not Evaluated",
  ScanTime:"Scan Time",
  Rescan: "Rescan",

},
//Data Management
DataManagement:{
  DataManagement:"gestion des données",
  AllCompanies:"Toutes les entreprises",
  CompaniesViewed:"Entreprises consultées",
  CompaniesCollected:"Les entreprises ont collecté",
  CompaniesUploaded:"Entreprises ayant publié",
  MyPortfolio:"Mon portefeuille",
  Date:"Date",
  CompanyName:"Nom de l'entreprise",
  Country:"Pays",
  CompanyType:"Type d'entreprise",
  CompanyStatus:"Statut de l'entreprise",
  DQI:"DQI",
  Download:"Télécharger",
  Addcompanies:"Ajouter des entreprises",
  Filter: "Filtrer",
  Selectcountry:"Sélectionnez un pays",
  Selectindustry:"Sélectionner le secteur d'activité",
  Selectcompanytype:"Sélectionnez le type d'entreprise",
  Selectcompanysize:"Sélectionnez la taille de l'entreprise",
  Selectcompanystatus:"Sélectionner le statut de l'entreprise",
  Selectlistedcompanies:"Sélectionner les sociétés cotées",
  Selectcompanyyearsinbusiness:"Sélectionnez l'ancienneté de l'entreprise.",
  Industry:"Industrie",
  CompanySize:"Taille de l'entreprise",
  Listed:"cotées",
  CompanyAge:"Âge de l'entreprise",
  SelectYear:"Sélectionner l'année",
  SelectQuarter:"Sélectionner le trimestre",
  SelectMonth:"Sélectionner le mois",
  Reset:"Réinitialiser",
  Search:"Recherche",
  MyDatabase:"Ma base de données",
  CountriesLocated:"Pays situés",
  YearsinBusiness:"Années d'activité",
  CompanyDQI:"DQI",
  RiskScan:"Analyse des risques",
  CreditAssessment:"Évaluation du crédit",
  Uptodate:"À jour",
  Average:"Moyenne",
  Insufficient:"Insuffisante",
  Good:"Bien",
  Caution:"Prudence",
  Unknown:"Inconnue",
  CompanyTag:"Étiquette de l'entreprise",
  Remove:"Retirer",
  Uploaded:"Téléchargé",
  Identified:"Identifié",
  Notmatched:"Non apparié",
  Uploadfiles:"Téléverser des fichiers",
  Identifythecompanywithmanualcheck:"Identifier l'entreprise par vérification manuelle",
  Identifyacompanymanually:"Identifier une entreprise manuellement",
  Pleaseprovideanyrelevantinformation:"Veuillez fournir toute information pertinente susceptible d'améliorer les résultats de la recherche. Notre analyste de données vous mettra en relation avec l'entreprise la plus adaptée à vos besoins.",
  RegistrationID:"ID d'entreprise",
  StateProvince:"État/Province",
  Address:"Adresse",
  Otherinformation:"Autres informations",
  Submit:"Soumettre",
  Cancel: "Annuler",
  Confirm:"Confirmer",
  PortolioName:"Nom du Portolio",
  User:"Utilisatrice",
  Task:"Tâche",
  NoofCompanies:"Nombre d'entreprises",
  Entercompanyname:"Saisissez le nom de l'entreprise",
  SaveYourPortfolio:"Sauvegardez votre portefeuille",
  PortfolioName:"Nom du Portolio",
  Notes:"Notes",

  //未对应
  Rescan:"Rescan",
  Match:"Match",
  Delete:"Delete",
  Edit:"Edit",
  AllData:"All Data",
  CountriesLocated:"Countries Located",
  EnterRegistrationID:"Enter Registration ID",
  EnterAddress:"Enter Address",
  EnterInformation:"Enter Information",
  EnterPortfolioName:"Enter Portfolio Name",
  EnterUserName:"Enter User",
  SelectTaskName:"Select Task",
  EnterNotes:"Enter Notes",
  OnlineMatching:"Online Matching",
  StartingMonth:"Starting Month",
  EndMonth:"End Month",
},
  ...frLocale,
};

export default fr;
